import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { LandingPageScreenContent } from './landing-page-screen-content.small';
export const LandingPageScreen: NavigationScreen<'landing-page'> = withOptionalMetrics(
  'LandingPageScreen',
  withErrorBoundary(LandingPageScreenContent),
);
